import { HStack, Td, Text, Tr } from '@chakra-ui/react';
import { R$ } from 'shared/helpers/currency';
import { IProduct, Product } from 'shared/models/product';
import EditServicePriceButton from '../atoms/EditServicePriceButton';
import DeleteServiceButton from '../atoms/DeleteServiceButton';
import PlanBadge from '../atoms/ServiceBadge/PlanBadge';

interface CollumnTextTheme {
  w: string;
  h: string;
  bg: string;
  color: string;
}
interface PlanTableLineProps {
  loading?: boolean;
  plan?: Product;
}

const PlanTableLine = ({ loading, plan }: PlanTableLineProps) => {
  if (!plan) {
    plan = new Product({} as IProduct);
  }

  let collumnTextTheme: CollumnTextTheme = {
    w: 'auto',
    h: 'auto',
    bg: 'transparent',
    color: '',
  };
  if (loading) {
    collumnTextTheme = {
      w: '80px',
      h: '20px',
      bg: 'yGray.50',
      color: 'transparent',
    };
  }

  return (
    <Tr>
      <Td>
        <PlanBadge loading={loading} product={plan} />
      </Td>
      <Td>
        <HStack spacing={1}>
          <Text
            w={collumnTextTheme.w}
            h={collumnTextTheme.h}
            bg={collumnTextTheme.bg}
            borderRadius="5px"
            color={collumnTextTheme.color}
          >
            {plan.priceString}
          </Text>
          <EditServicePriceButton loading={loading} service={plan} />
        </HStack>
      </Td>
      <Td>
        <Text
          w={collumnTextTheme.w}
          h={collumnTextTheme.h}
          bg={collumnTextTheme.bg}
          borderRadius="5px"
          color={collumnTextTheme.color}
        >
          {plan.discount?.discount_type === '%'
            ? `${plan.discount?.discount_value}%`
            : (R$(plan.discount_value) ?? '-')}
        </Text>
      </Td>
      <Td>
        <Text
          w={collumnTextTheme.w}
          h={collumnTextTheme.h}
          bg={collumnTextTheme.bg}
          borderRadius="5px"
          color={collumnTextTheme.color}
        >
          {plan.discount?.cycles && plan.discount.cycles > 0
            ? plan.discount.cycles
            : '-'}
        </Text>
      </Td>
      <Td>
        <Text
          w={collumnTextTheme.w}
          h={collumnTextTheme.h}
          bg={collumnTextTheme.bg}
          borderRadius="5px"
          color={collumnTextTheme.color}
        >
          {plan.created_at ? plan.created_at.format('DD/MM/YYYY') : ''}
        </Text>
      </Td>
      <Td w="10px">
        <DeleteServiceButton loading={loading} service={plan} />
      </Td>
    </Tr>
  );
};
export default PlanTableLine;
